/* eslint-disable no-underscore-dangle */
((ns) => {
  const { logError } = ns;


  const initViewToggle = () => {
    try {
      const filterComponent = document.querySelector("filter-component");
      if (!filterComponent) return;

      // Get view toggle buttons
      const buttonList = filterComponent.querySelector(".view-as__list-button");
      const buttonGrid = filterComponent.querySelector(".view-as__grid-button");

      // Get the hits container
      const hitsContainer = document.querySelector("#hits");     

      if (!buttonList || !buttonGrid || !hitsContainer) return;

      // Remove existing event listeners to prevent duplicates
      const newButtonGrid = buttonGrid.cloneNode(true);
      const newButtonList = buttonList.cloneNode(true);
      buttonGrid.parentNode.replaceChild(newButtonGrid, buttonGrid);
      buttonList.parentNode.replaceChild(newButtonList, buttonList);

      // Add click handlers
      newButtonGrid.addEventListener("click", () => {
        try {
          // Update button states
          newButtonGrid.querySelector(".view-as__icon").classList.add("view-as__icon--active");
          newButtonList.querySelector(".view-as__icon").classList.remove("view-as__icon--active");

          // Update container class for grid view
          hitsContainer.classList.remove("search-products--list");
          hitsContainer.classList.add("search-products--grid");

          // Save preference
          localStorage.setItem("searchViewMode", "grid");

          // Trigger InstantSearch re-render
          if (window.__instantSearchInstance) {
            window.__instantSearchInstance.refresh();
          }
        } catch (error) {
          logError(error, "toggleGridView");
        }
      });

      newButtonList.addEventListener("click", () => {
        try {
          // Update button states
          newButtonList.querySelector(".view-as__icon").classList.add("view-as__icon--active");
          newButtonGrid.querySelector(".view-as__icon").classList.remove("view-as__icon--active");

          // Update container class for list view
          hitsContainer.classList.remove("search-products--grid");
          hitsContainer.classList.add("search-products--list");       

          // Save preference
          localStorage.setItem("searchViewMode", "list");

          // Trigger InstantSearch re-render
          if (window.__instantSearchInstance) {
            window.__instantSearchInstance.refresh();
          }
        } catch (error) {
          logError(error, "toggleListView");
        }
      });

      // Apply saved preference on load
      const savedView = localStorage.getItem("searchViewMode") || "grid";
      if (savedView === "list") {
        newButtonList.click();
      } else {
        newButtonGrid.click();
      }

      (function () {
        const el = document.querySelector('.show_mobile_sticky');
        const pagination = document.querySelector('#pagination');
        if (!el) return;  

        let isActive = false;
        let lastScrollY = window.scrollY;

        // the scroll point where the element should activate
        const triggerPoint = el.offsetTop;

        // function isInViewport(elem) {
        //   const rect = elem.getBoundingClientRect();
        //   return rect.top < window.innerHeight && rect.bottom > 0;
        // }        

        function check() {
          const scrollY = window.scrollY;
          const direction = scrollY > lastScrollY ? "down" : "up";
          lastScrollY = scrollY;

          const rect = pagination.getBoundingClientRect();

          const paginationEnteringFromBottom = rect.top < window.innerHeight && rect.bottom > window.innerHeight;
          const paginationLeavingAtBottom = rect.top >= window.innerHeight;
          const paginationLeavingAtTop = rect.bottom <= 0;

          // --- RULE 1: Pagination enters from bottom → hide sticky
          if (paginationEnteringFromBottom && direction === "down") {
            el.classList.remove('active');
            isActive = false;
            return;
          }

          // --- RULE 2: Pagination leaves at top → keep sticky hidden
          if (paginationLeavingAtTop) {
            el.classList.remove('active');
            isActive = false;
            return;
          }

          // --- RULE 3: Pagination leaves at bottom → allow sticky to show again
          if (paginationLeavingAtBottom) {
            if (scrollY >= triggerPoint && direction === "up") {
              el.classList.add('active');
              isActive = true;
            }
            // Don't return → allow normal sticky logic below
          }

          // ---- NORMAL sticky logic (only when pagination not interfering)
          if (!isActive && scrollY >= triggerPoint) {
            el.classList.add('active');
            isActive = true;
          }

          if (isActive && scrollY < triggerPoint) {
            el.classList.remove('active');
            isActive = false;
          }
        }

        window.addEventListener('scroll', check, { passive: true });
        check(); // initial run
      })();      

    } catch (error) {
      logError(error, "initViewToggle");
    }
  };

  // Function to maintain view state after InstantSearch renders
  const maintainViewState = () => {
    const currentView = localStorage.getItem("searchViewMode") || "grid";
    const hits = document.querySelector("#hits");
    if (hits) {
      hits.classList.remove("search-products--grid", "search-products--list");
      hits.classList.add(`search-products--${currentView}`);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initViewToggle();

      // Set up observer to watch for InstantSearch updates
      const observer = new MutationObserver(maintainViewState);

      const hitsContainer = document.querySelector("#hits");
      if (hitsContainer) {
        observer.observe(hitsContainer, { childList: true, subtree: true });
      }
    });
  } else {
    initViewToggle();

    // Set up observer to watch for InstantSearch updates
    const observer = new MutationObserver(maintainViewState);

    const hitsContainer = document.querySelector("#hits");
    if (hitsContainer) {
      observer.observe(hitsContainer, { childList: true, subtree: true });
    }
  }

  // Re-initialize view toggle when filter component updates
  document.addEventListener("filterUpdate", () => {
    setTimeout(initViewToggle, 100);
  });

  Object.assign(ns, { initViewToggle, maintainViewState });
})((window.ProductSearch = window.ProductSearch || {}));